// FormModal.js

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleModal } from '../../reducers/UiReducer';

const FloatingIcon = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(state => state.ui.isModalOpen); 

  const handleClose = () => {
    dispatch(toggleModal(false)); 
  };

  if (!isModalOpen) return null; 

  return (
    <div className="modal-overlay">
      <div className="modal">
        <button onClick={handleClose} className="close-btn">X</button>
        <h2>Get a Free Quote</h2>
        <form>
          <div>
            <label htmlFor="name">Name</label>
            <input type="text" id="name" name="name" placeholder="Enter your name" required />
          </div>
          <div>
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" placeholder="Enter your email" required />
          </div>
          <div>
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" placeholder="Enter your message" required></textarea>
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default FloatingIcon;
